import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Datatable from "../../../Components/ExtraComponents/Datatable";
import { ClientAction } from "../../../ReduxStore/Slice/Client/ClientSlice";
import { useNavigate, useLocation } from "react-router-dom";
import {
  JobAction,
  Update_Status,
  getAllCustomerDropDown,
} from "../../../ReduxStore/Slice/Customer/CustomerSlice";
import { getList } from "../../../ReduxStore/Slice/Settings/settingSlice";
import sweatalert from "sweetalert2";
import Hierarchy from "../../../Components/ExtraComponents/Hierarchy";
import { MasterStatusData } from "../../../ReduxStore/Slice/Settings/settingSlice";
import ExportToExcel from "../../../Components/ExtraComponents/ExportToExcel";
import Select from "react-select";
import ReactPaginate from "react-paginate";

const ClientLists = () => {
  const navigate = useNavigate();
  const customer_id_sidebar = sessionStorage.getItem("customer_id_sidebar");
  const [CustomerData, setCustomerData] = useState([]);
  const [customerId, setCustomerId] = useState(customer_id_sidebar || "");
  const [customerName, setCustomerName] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const GetAllCustomer = async () => {
    const req = { action: "get_dropdown" };
    const data = { req: req, authToken: token };
    await dispatch(getAllCustomerDropDown(data))
      .unwrap()
      .then(async (response) => {
        if (response.status) {
          setCustomerData(response.data);
        } else {
          setCustomerData([]);
        }
      })
      .catch((error) => {
        return;
      });
  };

  useEffect(() => {
    GetAllCustomer();
  }, []);

  const location = useLocation();
  const dispatch = useDispatch();
  const token = JSON.parse(localStorage.getItem("token"));
  const [ClientData, setClientData] = useState([]);
  const [getJobDetails, setGetJobDetails] = useState([]);
  const [getCheckList, setCheckList] = useState([]);
  const [getCheckList1, setCheckList1] = useState([]);
  const [hararchyData, setHararchyData] = useState({
    customer: { id: customerId, trading_name: customerName },
  });
  const [selectStatusIs, setStatusId] = useState("");
  const [statusDataAll, setStatusDataAll] = useState([]);
  const [getAccessDataClient, setAccessDataClient] = useState({
    insert: 0,
    update: 0,
    delete: 0,
    client: 0,
    all_clients: 0,
  });
  const [getAccessDataJob, setAccessDataJob] = useState({
    insert: 0,
    update: 0,
    delete: 0,
    job: 0,
    all_jobs: 0,
  });
  const [activeTab, setActiveTab] = useState("");
  const role = JSON.parse(localStorage.getItem("role"));

  const [getAccessDataCustomer, setAccessDataCustomer] = useState({
    insert: 0,
    update: 0,
    delete: 0,
    view: 0,
    all_customers: 0,
  });

  const accessDataCustomer =
    JSON.parse(localStorage.getItem("accessData") || "[]").find(
      (item) => item.permission_name === "customer"
    )?.items || [];

  const accessDataCustomerAll =
    JSON.parse(localStorage.getItem("accessData") || "[]").find(
      (item) => item.permission_name === "all_customers"
    )?.items || [];

  useEffect(() => {
    if (accessDataCustomer.length === 0) return;
    const updatedAccess = {
      insert: 0,
      update: 0,
      delete: 0,
      view: 0,
      all_customers: 0,
    };
    accessDataCustomer.forEach((item) => {
      if (item.type === "insert") updatedAccess.insert = item.is_assigned;
      if (item.type === "update") updatedAccess.update = item.is_assigned;
      if (item.type === "delete") updatedAccess.delete = item.is_assigned;
      if (item.type === "view") updatedAccess.view = item.is_assigned;
    });
    accessDataCustomerAll.forEach((item) => {
      if (item.type === "view") updatedAccess.all_customers = item.is_assigned;
    });
    setAccessDataCustomer(updatedAccess);
  }, []);

  useEffect(() => {
    const retrievedData = sessionStorage.getItem("activeTab");
    const retrievedData1 = sessionStorage.getItem("activeTab1");
    if (retrievedData && retrievedData !== "clear") {
      setActiveTab(retrievedData);
      sessionStorage.setItem("activeTab1", "clear");
    } else if (retrievedData1 == "clear") {
      setActiveTab(retrievedData);
    } else {
      setActiveTab(
        (getAccessDataClient &&
          (getAccessDataClient.client == 1 ||
            getAccessDataClient.all_clients == 1)) ||
          role === "SUPERADMIN"
          ? "client"
          : (getAccessDataJob &&
              (getAccessDataJob.job == 1 || getAccessDataJob.all_jobs == 1)) ||
            role === "SUPERADMIN"
          ? "job"
          : "documents"
      );
    }
  }, [getAccessDataJob, getAccessDataClient]);

  const initialTabs = [];

  const [tabs, setTabs] = useState(initialTabs);

  const accessDataClient =
    JSON.parse(localStorage.getItem("accessData") || "[]").find(
      (item) => item.permission_name === "client"
    )?.items || [];

  const accessDataClientAll =
    JSON.parse(localStorage.getItem("accessData") || "[]").find(
      (item) => item.permission_name === "all_clients"
    )?.items || [];

  const accessDataJob =
    JSON.parse(localStorage.getItem("accessData") || "[]").find(
      (item) => item.permission_name === "job"
    )?.items || [];

  const accessDataJobAll =
    JSON.parse(localStorage.getItem("accessData") || "[]").find(
      (item) => item.permission_name === "all_jobs"
    )?.items || [];

  useEffect(() => {
    if (accessDataClient.length === 0) return;
    const updatedAccess = {
      insert: 0,
      update: 0,
      delete: 0,
      client: 0,
      all_clients: 0,
    };
    accessDataClient.forEach((item) => {
      if (item.type === "insert") updatedAccess.insert = item.is_assigned;
      if (item.type === "update") updatedAccess.update = item.is_assigned;
      if (item.type === "delete") updatedAccess.delete = item.is_assigned;
      if (item.type === "view") updatedAccess.client = item.is_assigned;
    });

    accessDataClientAll.forEach((item) => {
      if (item.type === "view") updatedAccess.all_clients = item.is_assigned;
    });
    setAccessDataClient(updatedAccess);
  }, []);

  useEffect(() => {
    if (accessDataJob.length === 0) return;
    const updatedAccess = {
      insert: 0,
      update: 0,
      delete: 0,
      job: 0,
      all_jobs: 0,
    };
    accessDataJob.forEach((item) => {
      if (item.type === "insert") updatedAccess.insert = item.is_assigned;
      if (item.type === "update") updatedAccess.update = item.is_assigned;
      if (item.type === "delete") updatedAccess.delete = item.is_assigned;
      if (item.type === "view") updatedAccess.job = item.is_assigned;
    });

    accessDataJobAll.forEach((item) => {
      if (item.type === "view") updatedAccess.all_jobs = item.is_assigned;
    });
    setAccessDataJob(updatedAccess);
  }, []);

  const SetTab = (e) => {
    setActiveTab(e);
    setCurrentPage(1);
    setSearchTerm("");
  };

  useEffect(() => {
    GetStatus();
    if (activeTab !== "") {
      if (activeTab === "checklist") {
        getCheckListData();
      } else if (activeTab === "client") {
        GetAllClientData(customerId, 1, pageSize, "");
      } else if (activeTab === "job") {
        JobDetails(1, pageSize, "");
      }
    }
  }, [activeTab]);

  useEffect(() => {
    if (getCheckList) {
      const filteredData = getCheckList.filter((item) =>
        Object.values(item).some((val) =>
          val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      setCheckList1(filteredData);
    } else {
      setCheckList1([]);
    }
  }, [searchTerm, getCheckList]);

  useEffect(() => {
    let tabsData = [];
    if (
      (getAccessDataClient &&
        (getAccessDataClient.client == 1 ||
          getAccessDataClient.all_clients == 1)) ||
      role === "SUPERADMIN"
    ) {
      tabsData.push({
        id: "client",
        label: "Client",
        icon: "fa-solid fa-user",
      });
    }
    if (
      (getAccessDataJob &&
        (getAccessDataJob.job == 1 || getAccessDataJob.all_jobs == 1)) ||
      role === "SUPERADMIN"
    ) {
      if (customerId != "") {
        tabsData.push({
          id: "job",
          label: "Job",
          icon: "fa-solid fa-briefcase",
        });
      }
    }

    setTabs([...tabsData, ...initialTabs]);
  }, [getAccessDataJob, getAccessDataClient, ClientData, customerId]);

  const ClientListColumns = [
    {
      name: "Client Name",
      cell: (row) => (
        <div>
          {getAccessDataJob.job === 1 ||
          getAccessDataJob.all_jobs == 1 ||
          role === "SUPERADMIN" ? (
            <a
              onClick={() => HandleClientView(row)}
              style={{ cursor: "pointer", color: "#26bdf0" }}
            >
              {row.client_name}
            </a>
          ) : (
            row.client_name
          )}
        </div>
      ),
      selector: (row) => row.client_name,
      sortable: true,
    },
    {
      name: "Client Code",
      cell: (row) => (
        <div title={row.client_code || "-"}>{row.client_code || "-"}</div>
      ),
      selector: (row) => row.client_code || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Customer Name",
      cell: (row) => (
        <div title={row.customer_name || "-"}>{row.customer_name || "-"}</div>
      ),
      selector: (row) => row.customer_name || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Client Type",
      selector: (row) =>
        row.client_type_name == null ? "-" : row.client_type_name,
      sortable: true,
      width: "150px",
      reorder: false,
    },
    {
      name: "Created By",
      cell: (row) => (
        <div title={row.client_created_by || "-"}>
          {row.client_created_by || "-"}
        </div>
      ),
      selector: (row) => row.client_created_by || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Created At",
      cell: (row) => (
        <div title={row.created_at || "-"}>{row.created_at || "-"}</div>
      ),
      selector: (row) => row.created_at || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Status",
      selector: (row) => (
        <div>
          <span
            className={` ${
              row.status === "1" ? "text-success" : "text-danger"
            }`}
          >
            {row.status === "1" ? "Active" : "Deactive"}
          </span>
        </div>
      ),
      sortable: true,
      width: "130px",
      reorder: false,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex">
          {getAccessDataClient.update === 1 || role === "SUPERADMIN" ? (
            <button
              className="edit-icon"
              onClick={() =>
                navigate("/admin/client/edit", {
                  state: { row, id: customerId, activeTab: activeTab },
                })
              }
            >
              <i className="ti-pencil" />
            </button>
          ) : null}
          {getAccessDataClient.delete === 1 || role === "SUPERADMIN" ? (
            <>
              {row?.Delete_Status == null && (
                <button
                  className="delete-icon"
                  onClick={() => handleDelete(row, "client")}
                >
                  {" "}
                  <i className="ti-trash text-danger" />
                </button>
              )}
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      reorder: false,
    },
  ];

  const JobColumns = [
    {
      name: "Job ID (CustName+ClientName+UniqueNo)",
      cell: (row) => (
        <div>
          <a
            onClick={() => HandleJobView(row)}
            style={{ cursor: "pointer", color: "#26bdf0" }}
          >
            {row.job_code_id}
          </a>
        </div>
      ),
      selector: (row) => row.job_code_id,
      sortable: true,
      reorder: false,
    },
    {
      name: "Job Priority",
      cell: (row) => {
        const v = row.job_priority || "-";
        const cap = v.charAt(0).toUpperCase() + v.slice(1).toLowerCase();
        return <div title={cap}>{cap}</div>;
      },
      selector: (row) => {
        if (!row.job_priority) return "-";
        return (
          row.job_priority.charAt(0).toUpperCase() +
          row.job_priority.slice(1).toLowerCase()
        );
      },
      sortable: true,
    },
    {
      name: "Client Name",
      cell: (row) => (
        <div title={row.client_trading_name || "-"}>
          {row.client_trading_name || "-"}
        </div>
      ),
      selector: (row) => row.client_trading_name || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Job Type",
      cell: (row) => (
        <div title={row.job_type_name || "-"}>{row.job_type_name || "-"}</div>
      ),
      selector: (row) => row.job_type_name || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Status",
      cell: (row) => (
        <div>
          <div>
            <select
              className="form-select form-control"
              value={row.status_type}
              onChange={(e) => handleStatusChange(e, row)}
              disabled={
                getAccessDataJob.update === 1 || role === "SUPERADMIN"
                  ? false
                  : true
              }
            >
              {statusDataAll.map((status) => (
                <option key={status.id} value={status.id}>
                  {status.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      ),
      sortable: true,
      width: "325px",
      reorder: false,
    },
    {
      name: "Client Contact Person",
      cell: (row) => (
        <div
          title={
            row.account_manager_officer_first_name +
              " " +
              row.account_manager_officer_last_name || "-"
          }
        >
          {row.account_manager_officer_first_name +
            " " +
            row.account_manager_officer_last_name || "-"}
        </div>
      ),
      selector: (row) =>
        row.account_manager_officer_first_name +
          " " +
          row.account_manager_officer_last_name || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Client Job Code",
      cell: (row) => (
        <div title={row.client_job_code || "-"}>
          {row.client_job_code || "-"}
        </div>
      ),
      selector: (row) => row.client_job_code || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Outbook Account Manager",
      cell: (row) => (
        <div
          title={
            row.outbooks_acount_manager_first_name +
              " " +
              row.outbooks_acount_manager_last_name || "-"
          }
        >
          {row.outbooks_acount_manager_first_name +
            " " +
            row.outbooks_acount_manager_last_name || "-"}
        </div>
      ),
      selector: (row) =>
        row.outbooks_acount_manager_first_name +
          " " +
          row.outbooks_acount_manager_last_name || "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Allocated To",
      selector: (row) =>
        row.allocated_id != null
          ? row.allocated_first_name + " " + row.allocated_last_name
          : "",
      sortable: true,
    },
    {
      name: "Timesheet",
      cell: (row) => (
        <div
          title={
            row.total_hours_status == "1" && row.total_hours != null
              ? row.total_hours.split(":")[0] +
                "h " +
                row.total_hours.split(":")[1] +
                "m"
              : "-"
          }
        >
          {row.total_hours_status == "1" && row.total_hours != null
            ? row.total_hours.split(":")[0] +
              "h " +
              row.total_hours.split(":")[1] +
              "m"
            : "-"}
        </div>
      ),
      selector: (row) =>
        row.total_hours_status == "1" && row.total_hours != null
          ? row.total_hours.split(":")[0] +
            "h " +
            row.total_hours.split(":")[1] +
            "m"
          : "-",
      sortable: true,
      reorder: false,
    },
    {
      name: "Invoicing",
      selector: (row) => (row.invoiced == "1" ? "YES" : "NO"),
      sortable: true,
      reorder: false,
    },
    {
      name: "Created By",
      cell: (row) => (
        <div title={row.job_created_by || "-"}>{row.job_created_by || "-"}</div>
      ),
      selector: (row) => row.job_created_by || "-",
      sortable: true,
    },
    {
      name: "Created At",
      cell: (row) => (
        <div title={row.created_at || "-"}>{row.created_at || "-"}</div>
      ),
      selector: (row) => row.created_at || "-",
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex">
          {getAccessDataJob.update === 1 || role === "SUPERADMIN" ? (
            <button
              className="edit-icon"
              onClick={() =>
                navigate("/admin/job/edit", {
                  state: {
                    job_id: row.job_id,
                    goto: "Customer",
                    activeTab: activeTab,
                  },
                })
              }
            >
              <i className="ti-pencil" />
            </button>
          ) : null}
          {row.timesheet_job_id == null ? (
            getAccessDataJob.delete === 1 || role === "SUPERADMIN" ? (
              <button
                className="delete-icon"
                onClick={() => handleDelete(row, "job")}
              >
                <i className="ti-trash text-danger" />
              </button>
            ) : null
          ) : (
            ""
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      reorder: false,
    },
  ];

  const handleStatusChange = (e, row) => {
    const Id = e.target.value;
    sweatalert
      .fire({
        title: "Are you sure?",
        text: "Do you want to change the status?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, change it!",
        cancelButtonText: "No, cancel",
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const req = { job_id: row.job_id, status_type: Number(Id) };
            const res = await dispatch(
              Update_Status({ req, authToken: token })
            ).unwrap();

            if (res.status) {
              sweatalert.fire({
                title: "Success",
                text: res.message,
                icon: "success",
                timer: 1000,
                showConfirmButton: false,
              });

              setStatusId(Id);
              JobDetails(currentPage, pageSize, searchTerm);
            } else if (res.data === "W") {
              sweatalert.fire({
                title: "Warning",
                text: res.message,
                icon: "warning",
                confirmButtonText: "Ok",
                timer: 3000,
                timerProgressBar: true,
              });
            } else {
              sweatalert.fire({
                title: "Error",
                text: res.message,
                icon: "error",
                confirmButtonText: "Ok",
                timer: 1000,
                timerProgressBar: true,
              });
            }
          } catch (error) {
            sweatalert.fire({
              title: "Error",
              text: "An error occurred while updating the status.",
              icon: "error",
              confirmButtonText: "Ok",
              timer: 1000,
              timerProgressBar: true,
            });
          }
        } else if (result.dismiss === sweatalert.DismissReason.cancel) {
          sweatalert.fire({
            title: "Cancelled",
            text: "Status change was not performed",
            icon: "error",
            confirmButtonText: "Ok",
            timer: 1000,
            timerProgressBar: true,
          });
        }
      });
  };

  const GetStatus = async () => {
    const data = { req: { action: "get" }, authToken: token };
    await dispatch(MasterStatusData(data))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setStatusDataAll(response.data);
        } else {
          setStatusDataAll([]);
        }
      })
      .catch((error) => {
        return;
      });
  };

  const CheckListColumns = [
    {
      name: "Checklist Name",
      cell: (row) => (
        <div>
          <a title={row.check_list_name}>{row.check_list_name}</a>
        </div>
      ),
      selector: (row) => row.check_list_name,
      sortable: true,
    },
    {
      name: "Service Type",
      cell: (row) => <div title={row.service_name}>{row.service_name}</div>,
      selector: (row) => row.service_name,
      sortable: true,
    },
    {
      name: "Job Type",
      cell: (row) => <div title={row.job_type_type}>{row.job_type_type}</div>,
      selector: (row) => row.job_type_type,
      sortable: true,
      width: "200px",
    },
    {
      name: "Client Type",
      cell: (row) => (
        <div title={row.client_type_type}>{row.client_type_type}</div>
      ),
      selector: (row) => row.client_type_type,
      sortable: true,
      width: "200px",
    },
    {
      name: "Status",
      selector: (row) => (row.status == "1" ? "Active" : "Deactive"),
      sortable: true,
      width: "150px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex">
          {getAccessDataCustomer.update === 1 || role === "SUPERADMIN" ? (
            <button
              className="edit-icon"
              onClick={() =>
                navigate("/admin/edit/checklist", {
                  state: {
                    id: customerId,
                    checklist_id: row.checklists_id,
                    activeTab: activeTab,
                  },
                })
              }
            >
              <i className="ti-pencil" />
            </button>
          ) : null}
          {getAccessDataCustomer.delete === 1 || role === "SUPERADMIN" ? (
            <button
              className="delete-icon"
              onClick={() => ChecklistDelete(row)}
            >
              <i className="ti-trash text-danger" />
            </button>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const tabs1 = [
    {
      key: "client",
      title: "Clients",
      placeholder: "Search clients...",
      data: ClientData,
      columns: ClientListColumns,
    },
    {
      key: "job",
      title: "Jobs",
      placeholder: "Search jobs...",
      data: getJobDetails,
      columns: JobColumns,
    },
    {
      key: "documents",
      title: "Documents",
      placeholder: null,
      data: [],
      columns: ClientListColumns,
    },
    {
      key: "status",
      title: "Status",
      placeholder: "Search Status...",
      data: [],
      columns: JobColumns,
    },
    {
      key: "checklist",
      title: "Checklist",
      placeholder: "Search...",
      data: getCheckList1,
      columns: CheckListColumns,
    },
  ];

  // Pagination handlers
  const handlePageChange = (selected) => {
    const newPage = selected.selected + 1;
    setCurrentPage(newPage);

    if (activeTab === "client") {
      GetAllClientData(customerId, newPage, pageSize, searchTerm);
    } else if (activeTab === "job") {
      JobDetails(newPage, pageSize, searchTerm);
    }
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);

    if (activeTab === "client") {
      GetAllClientData(customerId, 1, newSize, searchTerm);
    } else if (activeTab === "job") {
      JobDetails(1, newSize, searchTerm);
    }
  };

  const handleSearchChange = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);

    if (activeTab === "client") {
      GetAllClientData(customerId, 1, pageSize, term);
    } else if (activeTab === "job") {
      JobDetails(1, pageSize, term);
    }
  };

  const JobDetails = async (page = 1, limit = 10, search = "") => {
    const req = {
      action: "getByCustomer",
      customer_id: customerId,
      page,
      limit,
      search,
    };
    const data = { req: req, authToken: token };
    await dispatch(JobAction(data))
      .unwrap()
      .then(async (response) => {
        if (response.status) {
          setGetJobDetails(response.data);
          setTotalRecords(response.pagination?.total || 0);
        } else {
          setGetJobDetails([]);
          setTotalRecords(0);
        }
      })
      .catch((error) => {
        return;
      });
  };

  const GetAllClientData = async (id, page = 1, limit = 10, search = "") => {
    const req = {
      action: "get",
      customer_id: id,
      page,
      limit,
      search,
    };
    const data = { req: req, authToken: token };
    await dispatch(ClientAction(data))
      .unwrap()
      .then(async (response) => {
        if (response.status) {
          setClientData(response.data);
          setTotalRecords(response.pagination?.total || 0);
        } else {
          setClientData([]);
          setTotalRecords(0);
        }
      })
      .catch((error) => {
        return;
      });
  };

  const getCheckListData = async () => {
    const req = { action: "get", customer_id: customerId };
    const data = { req: req, authToken: token };
    await dispatch(getList(data))
      .unwrap()
      .then(async (response) => {
        if (response.status) {
          if (response.data.length > 0) {
            let Array = [
              { id: 1, name: "SoleTrader" },
              { id: 2, name: "Company" },
              { id: 3, name: "Partnership" },
              { id: 4, name: "Individual" },
            ];
            let data = response.data.map((item) => {
              return {
                ...item,
                check_list_name: item.check_list_name,
                service_name: item.service_name,
                job_type_type: item.job_type_type,
                status: item.status,
                checklists_id: item.checklists_id,
                client_type_type: item.checklists_client_type_id
                  .split(",")
                  .map((id) => {
                    let matchedItem = Array.find(
                      (item) => item.id === Number(id)
                    );
                    return matchedItem ? matchedItem.name : null;
                  })
                  .filter((name) => name !== null)
                  .join(", "),
              };
            });

            setCheckList(data);
            setCheckList1(data);
          } else {
            setCheckList([]);
          }
        } else {
          setCheckList([]);
        }
      })
      .catch((error) => {
        return;
      });
  };

  const ChecklistDelete = async (row) => {
    const req = { action: "delete", checklist_id: row.checklists_id };
    const data = { req: req, authToken: token };
    await dispatch(getList(data))
      .unwrap()
      .then(async (response) => {
        if (response.status) {
          sweatalert.fire({
            title: "Deleted",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500,
          });
          getCheckListData();
        } else {
          sweatalert.fire({
            title: "Failed",
            icon: "error",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      })
      .catch((error) => {
        return;
      });
  };

  const handleDelete = async (row, type) => {
    sweatalert
      .fire({
        title: "Are you sure?",
        text: "Do you want to delete this " + type + "?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const req = {
            action: "delete",
            ...(type === "job"
              ? { job_id: row.job_id }
              : { client_id: row.id }),
          };
          const data = { req: req, authToken: token };
          await dispatch(type == "job" ? JobAction(data) : ClientAction(data))
            .unwrap()
            .then(async (response) => {
              if (response.status) {
                sweatalert.fire({
                  title: type + " deleted successfully",
                  icon: "success",
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 1500,
                });
                if (type === "job") {
                  JobDetails(currentPage, pageSize, searchTerm);
                } else {
                  GetAllClientData(
                    customerId,
                    currentPage,
                    pageSize,
                    searchTerm
                  );
                }
              } else {
                sweatalert.fire({
                  title: "Failed",
                  icon: "error",
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            })
            .catch((error) => {
              return;
            });
        } else if (result.dismiss === sweatalert.DismissReason.cancel) {
          sweatalert.fire({
            title: "Cancelled",
            text: type + " was not deleted",
            icon: "error",
            confirmButtonText: "Ok",
            timer: 1000,
            timerProgressBar: true,
          });
        }
      });
  };

  const HandleClientView = (row) => {
    setHararchyData((prevState) => {
      const updatedData = {
        ...prevState,
        client: row,
      };
      navigate("/admin/client/profile", {
        state: { Client_id: row.id, data: updatedData, activeTab: activeTab },
      });
      return updatedData;
    });
  };

  const HandleJobView = (row) => {
    setHararchyData((prevState) => {
      const updatedData = {
        ...prevState,
        job: row,
      };
      navigate("/admin/job/logs", {
        state: {
          job_id: row.job_id,
          timesheet_job_id: row?.timesheet_job_id,
          goto: "Customer",
          data: updatedData,
          activeTab: activeTab,
        },
      });
      return updatedData;
    });
  };

  const selectCustomerId = (id, name) => {
    if (id != "") {
      sessionStorage.setItem("customer_id_sidebar", id);
      setCustomerId(id);
      setCustomerName(name);
      setHararchyData({ customer: { id: id, trading_name: name } });
      setActiveTab("client");
      setCurrentPage(1);
      setSearchTerm("");
      GetAllClientData(id, 1, pageSize, "");
    } else {
      sessionStorage.removeItem("customer_id_sidebar");
      setGetJobDetails([]);
      setCustomerId("");
      setCustomerName("");
      setClientData([]);
      setHararchyData({ customer: { id: "", trading_name: "" } });
      setCurrentPage(1);
      setSearchTerm("");
    }
  };

  const customerOptions = (CustomerData || [])
    .filter((val) => Number(val.status) === 1 && Number(val.form_process) === 4)
    .map((val) => ({
      value: val.id,
      label: val.trading_name,
    }));

  const selectedOption = customerOptions.find(
    (opt) => Number(opt.value) === Number(customerId)
  );

  const handleExport = async () => {
    let exportData = [];

    if (activeTab === "client") {
      const req = {
        action: "get",
        customer_id: customerId,
        page: 1,
        limit: 100000,
        search: "",
      };
      const data = { req, authToken: token };
      const response = await dispatch(ClientAction(data)).unwrap();

      if (!response.status || !response.data || response.data.length === 0) {
        alert("No data to export!");
        return;
      }

      exportData = response.data.map((item) => ({
        "Client Name": item.client_name,
        "Client Code": item.client_code,
        "Customer Name": item.customer_name,
        "Client Type Name": item.client_type_name,
        "Created By": item.client_created_by,
        "Created At": item.created_at,
        Status: item.status == 1 ? "Active" : "Deactive",
      }));
    } else if (activeTab === "job") {
      const req = {
        action: "getByCustomer",
        customer_id: customerId,
        page: 1,
        limit: 100000,
        search: "",
      };
      const data = { req, authToken: token };
      const response = await dispatch(JobAction(data)).unwrap();

      if (!response.status || !response.data || response.data.length === 0) {
        alert("No data to export!");
        return;
      }

      exportData = response.data.map((item) => ({
        "Job ID (CustName+ClientName+UniqueNo)": item.job_code_id,
        "Client Name": item.client_trading_name,
        "Job Type": item.job_type_name,
        Status: item.status,
        "Client Contact Person":
          item.account_manager_officer_first_name +
          " " +
          item.account_manager_officer_last_name,
        "Client Job Code": item.client_job_code,
        "Outbook Account Manager":
          item.outbooks_acount_manager_first_name +
          " " +
          item.outbooks_acount_manager_last_name,
        "Allocated To":
          item.allocated_id != null
            ? item.allocated_first_name + " " + item.allocated_last_name
            : "",
        Timesheet:
          item.total_hours_status == 1 && item.total_hours != null
            ? item.total_hours?.split(":")[0] +
              "h " +
              item.total_hours.split(":")[1] +
              "m"
            : "-",
        Invoicing: item.invoiced == 1 ? "YES" : "NO",
        "Created By": item.job_created_by,
        "Created At": item.created_at,
      }));
    }

    downloadCSV(
      exportData,
      `${activeTab === "client" ? "Client" : "Job"} Details.csv`
    );
  };

  const downloadCSV = (data, filename) => {
    const csvRows = [];
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));

    data.forEach((row) => {
      const values = headers.map((h) => `"${row[h] || ""}"`);
      csvRows.push(values.join(","));
    });

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    a.click();
  };

  return (
    <div className="container-fluid">
      <div className="content-title">
        <div className="row ">
          <div className="col-sm-12">
            <div className="form-group col-md-4 mb-0">
              <label className="form-label mb-2">Select Customer</label>
              <Select
                id="tabSelect"
                name="staff_id"
                className="basic-multi-select"
                classNamePrefix="react-select"
                isSearchable
                options={customerOptions}
                value={selectedOption}
                onChange={(selected) => {
                  const selectedCustomer = CustomerData.find(
                    (customer) => customer.id == selected.value
                  );
                  selectCustomerId(
                    selected.value,
                    selectedCustomer?.trading_name
                  );
                }}
                placeholder="Select Customer"
              />
            </div>

            <div className="page-title-box pt-2">
              <div className="row align-items-start flex-md-row flex-column-reverse">
                <div className="col-md-6 col-lg-8">
                  <ul
                    className="nav nav-pills rounded-tabs"
                    id="pills-tab"
                    role="tablist"
                  >
                    {tabs.map((tab) => (
                      <li className="nav-item" role="presentation" key={tab.id}>
                        <button
                          className={`nav-link ${
                            activeTab === tab.id ? "active" : ""
                          }`}
                          id={`${tab.id}-tab`}
                          data-bs-toggle="pill"
                          data-bs-target={`#${tab.id}`}
                          type="button"
                          role="tab"
                          aria-controls={tab.id}
                          aria-selected={activeTab === tab.id}
                          onClick={() => SetTab(tab.id)}
                        >
                          <i className={tab.icon}></i>
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-md-6 col-lg-4 d-block col-sm-auto d-sm-flex justify-content-end ps-lg-0">
                  {activeTab === "client" ||
                  activeTab === "checklist" ||
                  activeTab === "" ||
                  activeTab === "job" ? (
                    <>
                      {(getAccessDataClient.insert === 1 ||
                        role === "SUPERADMIN") &&
                      activeTab === "client" &&
                      customerId != "" ? (
                        <>
                          <div
                            className="btn btn-info text-white mt-2 mt-sm-0  blue-btn"
                            onClick={() =>
                              navigate("/admin/addclient", {
                                state: { id: customerId, activeTab: activeTab },
                              })
                            }
                          >
                            <i className="fa fa-plus pe-1" /> Add Client
                          </div>
                        </>
                      ) : ClientData?.length > 0 &&
                        (getAccessDataJob.insert == 1 ||
                          role === "SUPERADMIN") &&
                        activeTab === "job" ? (
                        <>
                          <div
                            className="btn btn-info text-white  blue-btn mt-2 mt-sm-0"
                            onClick={() =>
                              navigate("/admin/createjob", {
                                state: {
                                  customer_id: customerId,
                                  goto: "Customer",
                                  activeTab: activeTab,
                                },
                              })
                            }
                          >
                            <i className="fa fa-plus pe-1" /> Create Job
                          </div>
                        </>
                      ) : (getAccessDataCustomer.insert === 1 ||
                          role === "SUPERADMIN") &&
                        activeTab === "checklist" ? (
                        <>
                          <div
                            className="btn btn-info text-white  blue-btn mt-2 mt-sm-0"
                            onClick={() =>
                              navigate("/admin/create/checklist", {
                                state: { id: customerId, activeTab: activeTab },
                              })
                            }
                          >
                            <i className="fa fa-plus pe-1" /> Add Checklist
                          </div>
                        </>
                      ) : null}
                    </>
                  ) : activeTab === "documents" ? (
                    <>
                      <div
                        className="btn btn-info text-white float-sm-end blue-btn me-2 mt-2 mt-sm-0"
                        onClick={() => {
                          window.history.back();
                        }}
                      >
                        <i className="fa fa-arrow-left pe-1" /> Back
                      </div>
                    </>
                  ) : activeTab === "status" ? (
                    <>
                      <div
                        className="btn btn-info text-white float-sm-end blue-btn me-2 mt-2 mt-sm-0"
                        onClick={() => {
                          window.history.back();
                        }}
                      >
                        <i className="fa fa-arrow-left pe-1" /> Back
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        {customerId != "" ? (
          <Hierarchy
            show={["Customer", activeTab]}
            active={1}
            data={hararchyData}
            NumberOfActive={
              activeTab == "client"
                ? ClientData?.length
                : activeTab == "job"
                ? getJobDetails?.length
                : ""
            }
          />
        ) : (
          ""
        )}

        <div className="tab-content" id="pills-tabContent">
          {tabs1.map((tab) => (
            <div
              key={tab.key}
              className={`tab-pane fade ${
                activeTab == tab.key ? "show active" : ""
              }`}
              id={tab.key}
              role="tabpanel"
              aria-labelledby={`${tab.key}-tab`}
            >
              <div className="report-data mt-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="tab-title">
                    <h3 className="mt-0">{tab?.title}</h3>
                  </div>
                  {(activeTab === "client" || activeTab === "job") && (
                    <div className="col-md-2">
                      <button
                        className="btn btn-outline-info fw-bold float-end border-3"
                        onClick={handleExport}
                      >
                        Export Excel
                      </button>
                    </div>
                  )}
                </div>

                {(activeTab === "client" || activeTab === "job") && (
                  <div className="row mb-3 mt-3">
                    <div className="col-md-4">
                      <input
                        type="text"
                        placeholder={`Search ${tab?.title}...`}
                        className="form-control"
                        value={searchTerm}
                        onChange={(e) => handleSearchChange(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                <div className="datatable-wrapper">
                  {tab.data && tab.data.length > 0 ? (
                    <>
                      <Datatable
                        columns={tab.columns}
                        data={tab.data}
                        filter={false}
                        pagination={false}
                      />

                      {(activeTab === "client" || activeTab === "job") && (
                        <>
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={Math.ceil(totalRecords / pageSize)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            forcePage={currentPage - 1}
                          />

                          

                          <select
                            className="perpage-select"
                            value={pageSize}
                            onChange={handlePageSizeChange}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                          </select>
                        </>
                      )}
                    </>
                  ) : (
                    <div className="text-center">
                      <img
                        src="/assets/images/No-data-amico.png"
                        alt="No records available"
                        style={{
                          width: "250px",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                      <p>No data available.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientLists;
